const registrationConstants = {
  storageKey: 'registrationData'
}
export default registrationConstants
